export const ROOT = '/knowledgebase';
export const MODULE = 'KNOWLEDGEBASE';
